module.exports = __webpack_public_path__ + "static/offer-brand-basic-2-ab11d59d53e9174ed8ba28334afde448.jpg";